// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__XgHcP","listHorizontal":"List_listHorizontal__1r4Ig","listTitle":"List_listTitle__j7_Q_"};